/* Universal javascript */

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist'

import './alpine/store.js';
import './alpine/popovers.js';
import './alpine/skeleton.js';
import './alpine/whereAutocomplete.js';
// import './components/heroSearch.js';
import './components/bookingFlow.js';
import listingBooking from './alpine/listingBooking.js';
import { priceRange } from './components/priceRange.js';
import { inlineBirdhouseAnimation } from './components/inlineBirdhouseAnimation.js';
import { asideAnimation } from './components/asideAnimation.js';
import reviewsCarousel from './components/reviewsCarousel.js';

import disableTransitionOnResize from './utils/disableTransitionOnResize.js'
import swiper from './utils/swiper.js'
import animateIn from './utils/animateIn.js'
import htmxEvents from './utils/htmx.js'
import refreshCsrfToken from './utils/refresh-csrf-token.js'
import { initAttribution } from './utils/attribution.js'
import { initHubSpotAttribution } from './utils/hubspotAttribution.js'
import { initAuthListeners, initCardClickTracking, initViewItem } from './utils/dataLayer.js'


initAttribution();
initHubSpotAttribution();

// Register Alpine components
Alpine.data('listingBooking', listingBooking);

window.Alpine = Alpine;
Alpine.plugin(persist);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
    disableTransitionOnResize.init();
    swiper.init()
    inlineBirdhouseAnimation.init();
    asideAnimation.init();
    reviewsCarousel.init();
    animateIn.init();
    priceRange.autoInit();
    priceRange.watchDialogs();

    htmxEvents.init();
    initAuthListeners();
    initCardClickTracking();
    initViewItem();

    // Keep window.__csrfToken available for legacy custom JS requests, but only
    // after an intentional refresh. Do not fetch CSRF on page load; that can
    // race with Sprig forms that already rendered their own tokens.
    document.addEventListener('csrf:refreshed', (e) => {
        window.__csrfToken = e.detail;
    });

    if (typeof htmx !== 'undefined') {
        const refreshSharedCsrfToken = () => {
            refreshCsrfToken.getTokenAsync(true);
        };

        htmx.on('loginSucceeded', refreshSharedCsrfToken);
        htmx.on('signupSucceeded', refreshSharedCsrfToken);
    }
});
